import Immutable from 'immutable';
import { TOGGLE_FILTER_ABROAD } from '../actions/filter';

const FILTER = 'filter';
const FILTER_ABROAD = 'abroad';

const initialState = Immutable.fromJS({
    abroad: undefined,
});

export default function filter(state = initialState, action) {
    switch (action.type) {
        case TOGGLE_FILTER_ABROAD:
            return state.setIn([FILTER_ABROAD], action.payload);
        default:
            return state;
    }
}

export const filterAbroadSelector = (state) => state.getIn([FILTER, FILTER_ABROAD]);
